<template>
  <nav
    v-if="variants.HEADER_1 === variant"
    :class="[
      'tw-flex tw-items-center tw-justify-between tw-whitespace-nowrap tw-p-6 tw-text-center tw-duration-300 xl:tw-justify-around',
      'tw-fixed tw-left-0 tw-top-0 tw-z-50 tw-w-full tw-border-b',
    ]"
    :style="`
      ${
        isScrolled || vars.fixedColorBool || menuVisible
          ? `background-color: var(--c-${vars.backgroundColor});`
          : 'background-color: transparent;'
      }
      color: var(--c-${vars.textColor});
  `"
  >
    <div class="tw-max-w-48 tw-justify-center xl:tw-max-w-60">
      <nuxt-link style="all: unset !important" to="/" :external="true">
        <NuxtImg :src="logo" :alt="company.name" class="tw-cursor-pointer" />
      </nuxt-link>
    </div>
    <div class="tw-z-40 tw-flex tw-justify-start tw-pt-2 xl:tw-hidden">
      <button id="menu-button" class="focus:outline-none tw-flex" @click="toggleMenu">
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 27V24H31.5V27H4.5ZM4.5 19.5V16.5H31.5V19.5H4.5ZM4.5 12V9H31.5V12H4.5Z" fill="white" />
        </svg>
      </button>
    </div>
    <div class="tw-hidden xl:tw-block">
      <div class="tw-ml-4 tw-hidden xl:tw-block">
        <ul class="tw-flex tw-items-center tw-gap-6 tw-align-middle lg:tw-shrink">
          <li
            v-for="(menuGroup, groupIndex) in allMenu[0]"
            :key="`menuGroupIndex-${groupIndex}`"
            class="tw-group tw-relative tw-py-5"
          >
            <div class="tw-flex tw-items-center tw-justify-center">
              <nuxt-link
                :external="true"
                :to="menuGroup.url"
                :target="menuGroup.is_open_new_tab ? '_blank' : ''"
                class="n-link"
              >
                {{ menuGroup.name }}
              </nuxt-link>
              <span v-if="menuGroup.has_sub_menu" class="nc-icon-chevron-down sub-menu-arrow tw-ml-2"></span>
            </div>
            <ul
              v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
              class="tw-absolute tw-mt-3 tw-hidden tw-rounded-sm tw-px-6 tw-py-4 tw-text-left tw-text-white tw-shadow-md group-hover:!tw-block"
              :style="`background-color: var(--c-primary); border-radius: var(--rounded-sm);`"
            >
              <li
                v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
                :key="`${subMenuIndex}-subMenu-${groupIndex}`"
                class="tw-w-[220px] tw-py-4"
                style="border-color: var(--c-border)"
                :class="{
                  'tw-border-b': subMenuIndex !== menuGroup.sub_menus.length - 1,
                }"
              >
                <nuxt-link
                  class="n-link tw-block tw-px-4 tw-py-2 hover:tw-ml-4"
                  :external="true"
                  :to="subMenu.url"
                  :target="subMenu.is_open_new_tab ? '_blank' : ''"
                >
                  {{ subMenu.name }}
                </nuxt-link>
              </li>
            </ul>
          </li>
          <li>
            <nuxt-link
              v-if="vars.buttonLinkUrl"
              :to="vars.buttonLinkUrl"
              :external="true"
              :class="`n-${vars.buttonTypeText} tw-hidden sm:tw-block`"
              >{{ vars.buttonLabelText }}
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div
    v-if="variants.HEADER_1 === variant"
    class="tw-fixed -tw-top-[2000px] tw-left-0 tw-z-30 tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-overflow-y-auto tw-duration-300"
    :class="menuVisible === true ? '!tw-top-0' : '-tw-top-[1000px]'"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: var(--c-${vars.textColor});`"
  >
    <ul class="tw-mt-40 tw-flex tw-flex-col tw-items-center tw-pb-10">
      <li
        v-for="(menuGroup, groupIndex) in allMenu[0]"
        :key="`menuGroupIndex-${groupIndex}`"
        class="tw-group tw-relative tw-py-5"
      >
        <div class="tw-flex tw-items-center tw-justify-center">
          <nuxt-link
            :external="true"
            :to="menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            class="n-link"
          >
            {{ menuGroup.name }}
          </nuxt-link>
          <span
            v-if="menuGroup.has_sub_menu"
            class="nc-icon-chevron-down sub-menu-arrow theme3-menu-link tw-ml-2"
          ></span>
        </div>
        <ul
          v-if="menuGroup.sub_menus && menuGroup.sub_menus.length && menuGroup.has_sub_menu"
          class="tw-absolute tw-z-50 tw-mt-2 tw-hidden tw-rounded-sm tw-px-6 tw-py-4 tw-text-left tw-text-white tw-shadow-md group-hover:!tw-block"
          :style="`background-color: var(--c-primary); border-radius: var(--rounded-sm);`"
        >
          <li
            v-for="(subMenu, subMenuIndex) in menuGroup.sub_menus"
            :key="`${subMenuIndex}-subMenu-${groupIndex}`"
            class="tw-w-[150px] tw-py-4 md:tw-w-[220px]"
            style="border-color: var(--c-border)"
            :class="{
              'tw-border-b': subMenuIndex !== menuGroup.sub_menus.length - 1,
            }"
          >
            <nuxt-link
              class="n-link tw-block tw-px-4 tw-py-2 hover:tw-ml-4"
              :external="true"
              :to="subMenu.url"
              :target="subMenu.is_open_new_tab ? '_blank' : ''"
            >
              {{ subMenu.name }}
            </nuxt-link>
          </li>
        </ul>
      </li>
      <li class="tw-pt-5">
        <nuxt-link :external="true" to="/contact-us" class="n-outlined">GET IN TOUCH</nuxt-link>
      </li>
    </ul>
  </div>

  <div
    v-if="variants.HEADER_2 === variant"
    class="position-unset navbar tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-items-center tw-justify-between !tw-bg-opacity-90 tw-px-6 tw-py-4 tw-transition-all tw-duration-300 md:tw-px-20 xl:tw-px-32"
    :class="{ 'scrolled !tw-fixed': isScrolled }"
    :style="`
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-${vars.backgroundColor}); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }, ${vars.fixedColorBool ? `color: var(--c-text-primary);` : ''}
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
      z-index: 1001;
    `"
  >
    <nuxt-link to="/" :external="true" class="n-link tw-max-w-6">
      <div class="tw-w-32">
        <LibraryImage :src="logo" :h-ratio="1" :w-ratio="2" />
      </div>
    </nuxt-link>
    <div class="tw-flex tw-items-center tw-gap-6">
      <nuxt-link
        v-if="vars.buttonLinkUrl"
        :to="vars.buttonLinkUrl"
        :external="true"
        :class="`n-${vars.buttonTypeText} tw-hidden sm:tw-block`"
        >{{ vars.buttonLabelText }}
      </nuxt-link>
      <button
        class="icon burger-menu"
        @click="toggleActiveClass"
        :style="`${vars.fixedColorBool ? `color: var(--c-${vars.navTextColor}) !important` : ' color: var(--white)'};`"
      >
        <span
          :style="`background: ${isScrolled ? 'white' : vars.fixedColorBool ? 'white' : `var(--c-${vars.navTextColor})`}`"
        ></span>
        <span
          :style="`background: ${isScrolled ? 'white' : vars.fixedColorBool ? 'white' : `var(--c-${vars.navTextColor})`}`"
        ></span>
        <span
          :style="`background: ${isScrolled ? 'white' : vars.fixedColorBool ? 'white' : `var(--c-${vars.navTextColor})`}`"
        ></span>
      </button>
    </div>
  </div>
  <div
    v-if="variants.HEADER_2 === variant"
    class="nav-menu tw-fixed tw-inset-0 tw-z-40 tw-overflow-auto !tw-bg-opacity-90 tw-px-5 md:tw-px-14 xl:tw-px-28"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
  >
    <div class="tw-mt-32 tw-flex tw-w-full tw-flex-col tw-justify-start tw-gap-6 tw-py-10 lg:tw-flex-row lg:tw-gap-20">
      <ul class="tw-flex tw-flex-col tw-gap-6">
        <li
          v-for="(menuGroup, groupIndex) in leftMenu"
          :key="`menuGroupIndex-${groupIndex}`"
          class="nav-item tw-group tw-relative tw-duration-300"
          :style="`animation-delay: ${groupIndex * 0.2}s;`"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="n-link tw-duration-400 tw-text-start hover:tw-text-[var(--c-secondary)]"
          >
            <h2>{{ menuGroup.name }}</h2>
          </nuxt-link>
        </li>
      </ul>
      <ul class="tw-flex tw-flex-col tw-gap-6">
        <li
          v-for="(menuGroup, groupIndex) in rightMenu"
          :key="`menuGroupIndex-${groupIndex}`"
          class="nav-item tw-group tw-relative tw-duration-300"
          :style="`animation-delay: ${groupIndex * 0.2}s;`"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="n-link tw-duration-400 tw-text-start hover:tw-text-[var(--c-secondary)]"
          >
            <h2>{{ menuGroup.name }}</h2>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>

  <div
    v-if="variants.HEADER_3 === variant"
    class="position-unset navbar tw-absolute tw-left-0 tw-top-0 tw-z-50 tw-flex tw-w-full tw-items-center tw-justify-between !tw-bg-opacity-90 tw-px-6 tw-py-4 tw-transition-all tw-duration-300 md:tw-px-20 xl:tw-px-32"
    :class="{ 'scrolled !tw-fixed': isScrolled }"
    :style="`
      ${
        isScrolled || vars.fixedColorBool
          ? `background-color: var(--c-${vars.backgroundColor}); color: var(--c-text-primary);`
          : 'background-color: transparent;'
      }, ${vars.fixedColorBool ? `color: var(--c-text-primary);` : ''}
      color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary) '};
      z-index: 1001;
    `"
  >
    <nuxt-link to="/" :external="true" class="n-link tw-max-w-6">
      <div class="tw-w-32">
        <LibraryImage :src="logo" :h-ratio="1" :w-ratio="2" />
      </div>
    </nuxt-link>
    <div class="tw-flex tw-items-center tw-gap-6">
      <nuxt-link
        v-if="vars.buttonLinkUrl"
        :to="vars.buttonLinkUrl"
        :external="true"
        :class="`n-${vars.buttonTypeText} tw-hidden sm:tw-block`"
        >{{ vars.buttonLabelText }}
      </nuxt-link>
      <button
        class="icon burger-menu !tw-p-2"
        @click="toggleActiveClass"
        :style="`${vars.fixedColorBool ? `color: var(--c-${vars.navTextColor}) !important` : ' color: var(--white)'};`"
      >
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M28 12H8M40 24H8C18.1536 24 23.8464 24 34 24M40 36H20"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>
  <div
    v-if="variants.HEADER_3 === variant"
    class="nav-menu tw-fixed tw-inset-0 tw-z-40 tw-overflow-auto !tw-bg-opacity-90 tw-px-5 md:tw-px-14 xl:tw-px-28"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--white)'}`"
  >
    <div class="tw-absolute tw-bottom-0 tw-right-0 tw-z-0 tw-hidden md:tw-block">
      <svg width="673" height="714" viewBox="0 0 673 714" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_9_1925)">
          <path
            d="M24.6043 381.593C64.1642 321.155 138.942 304.278 193.618 314.404C261.803 327.103 312.298 384.969 333.525 449.907C343.817 482.376 346.712 516.613 340.922 547.797C333.525 586.856 313.423 615.628 297.985 633.47C295.895 635.399 295.412 637.971 296.377 639.257C297.181 640.382 298.79 640.382 299.915 640.221C302.649 639.739 304.257 637.81 306.187 636.203C308.117 634.595 309.725 632.666 311.655 630.738C315.192 627.201 318.569 623.504 321.947 619.486C328.701 611.77 334.651 603.573 340.279 595.214C345.747 586.856 350.571 577.855 354.752 568.693C359.094 559.53 362.632 550.208 365.527 540.563C368.421 530.919 370.833 521.114 372.281 511.148C373.889 501.343 374.854 491.217 375.175 481.09C375.336 470.964 374.854 460.837 374.05 450.711V449.907C372.763 440.102 370.994 430.136 368.582 420.492C367.296 415.67 365.848 411.169 364.562 406.507C360.541 394.291 353.787 382.879 349.606 370.824L451.883 269.558C558.341 314.083 566.542 317.458 673 361.661V689.729C673 692.783 672.357 695.676 671.07 698.569C667.693 707.41 659.009 713.679 648.878 713.679H136.208C136.53 713.679 136.691 713.357 137.012 713.196C148.108 706.767 174.803 688.443 188.794 654.205C206.322 610.806 197.478 555.994 160.33 521.275C153.415 514.524 145.375 509.059 137.012 504.719C97.4524 483.019 46.1532 484.948 5.78931 512.916C2.73389 501.343 -12.7042 438.334 24.6043 381.272"
            fill="#2D1559"
          />
          <path
            d="M366.009 290.133C366.009 292.865 366.009 295.437 366.331 298.17H306.83C307.152 295.437 307.152 292.865 307.152 290.133C307.152 226.159 262.124 174.562 206.483 174.562C150.842 174.562 197.639 174.883 193.297 175.687V0C238.485 0 275.472 36.8091 275.472 82.2981H398.011C398.011 36.8091 434.837 0 480.186 0V175.687C475.844 174.883 471.502 174.562 466.999 174.562C411.358 174.562 366.331 226.159 366.331 290.133"
            fill="#2D1559"
          />
        </g>
        <defs>
          <clipPath id="clip0_9_1925">
            <rect width="673" height="714" fill="white" transform="matrix(-1 0 0 1 673 0)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div
      class="tw-z-10 tw-mt-32 tw-flex tw-w-full tw-flex-col tw-justify-start tw-gap-6 tw-py-10 lg:tw-flex-row lg:tw-gap-20"
    >
      <ul class="tw-flex tw-flex-col tw-gap-6">
        <li
          v-for="(menuGroup, groupIndex) in leftMenu"
          :key="`menuGroupIndex-${groupIndex}`"
          class="nav-item tw-group tw-relative tw-duration-300"
          :style="`animation-delay: ${groupIndex * 0.2}s;`"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="n-link tw-duration-400 tw-text-start hover:tw-text-[var(--c-secondary)]"
          >
            <h2>{{ menuGroup.name }}</h2>
          </nuxt-link>
        </li>
      </ul>
      <ul class="tw-flex tw-flex-col tw-gap-6">
        <li
          v-for="(menuGroup, groupIndex) in rightMenu"
          :key="`menuGroupIndex-${groupIndex}`"
          class="nav-item tw-group tw-relative tw-duration-300"
          :style="`animation-delay: ${groupIndex * 0.2}s;`"
        >
          <nuxt-link
            :to="menuGroup.has_sub_menu ? '' : menuGroup.url"
            :target="menuGroup.is_open_new_tab ? '_blank' : ''"
            :external="true"
            class="n-link tw-duration-400 tw-text-start hover:tw-text-[var(--c-secondary)]"
          >
            <h2>{{ menuGroup.name }}</h2>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia';
import { MenuTypes, ViewTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';

type Menu = {};

export default defineNuxtComponent({
  name: 'Theme5BaseHeaderOne',

  mixins: [ComponentMixin],

  props: {
    component: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      ViewTypes,
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null,
      variants: {
        HEADER_1: 'HEADER_1',
        HEADER_2: 'HEADER_2',
        HEADER_3: 'HEADER_3',
      },
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['headerMenuItems']),
    ...mapState(useCoreStore, ['isAnythingOnTopVisible']),

    headerMenu() {
      return this.headerMenuItems as Menu[];
    },

    routeUrl() {
      const route = useRoute();
      return route.path;
    },

    leftMenu() {
      return this.allMenuV2[0].slice(0, 7);
    },
    rightMenu() {
      return this.allMenuV2[0].slice(7);
    },

    allMenu() {
      const period = 9;
      const columnsCount = Math.ceil(this.columnOneMenu.length / period);
      const groups = [];

      for (let i = 0; i < columnsCount; i++) {
        groups[i] = [];
        for (let p = 0; p < period; p++) {
          const index = period * i + p;
          if (this.columnOneMenu[index]) {
            groups[i].push(this.columnOneMenu[index]);
          }
        }
      }

      return groups;
    },

    allMenuV2() {
      const period = 20;
      const columnsCount = Math.ceil(this.columnOneMenu.length / period);
      const groups = [];

      for (let i = 0; i < columnsCount; i++) {
        groups[i] = [];
        for (let p = 0; p < period; p++) {
          const index = period * i + p;
          if (this.columnOneMenu[index]) {
            groups[i].push(this.columnOneMenu[index]);
          }
        }
      }

      return groups;
    },

    logo() {
      if (this.menuVisible) {
        return this.company.light_logo || this.company.logo;
      } else if (this.isScrolled) {
        return this.company.logo;
      } else if (!this.vars.fixedColorBool && !this.isScrolled) {
        return this.company.light_logo || this.company.logo;
      }
      return this.company.logo;
    },

    columnOneMenu() {
      const content = this.component.variables['column_one_content-text'];
      if (content === MenuTypes.HEADER_MENU) {
        return this.headerMenu;
      }
      return [];
    },
  },

  methods: {
    toggleSubMenu(index) {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },

    toggleBurgerMenu() {
      if (!this.menuVisible) {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('nav-item-visible');
          }, index * 100);
        });
      } else {
        const navItems = document.querySelectorAll('.nav-item');
        navItems.forEach((item, index) => {
          setTimeout(
            () => {
              item.classList.remove('nav-item-visible');
            },
            (navItems.length - index) * 100,
          );
        });
        setTimeout(() => {
          this.menuVisible = false;
          document.body.classList.remove('burger-menu-visible');
          document.body.classList.remove('no-scroll');
        }, navItems.length * 50);
        return;
      }

      this.menuVisible = !this.menuVisible;
      document.body.classList.toggle('burger-menu-visible', this.menuVisible);
      if (this.menuVisible && (this.variants.HEADER_2 || this.variants.HEADER_3 === this.variant)) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },

    handleScroll() {
      this.isScrolled =
        window.scrollY > (this.variant === this.variants.HEADER_2 || this.variant === this.variants.HEADER_3 ? 400 : 0);
    },

    toggleActiveClass() {
      const burgerMenu = document.querySelector('.burger-menu');
      burgerMenu.classList.toggle('active');
      burgerMenu.querySelectorAll('span').forEach((span) => {
        span.classList.toggle('active');
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    if (this.variants.HEADER_2 === this.variant || this.variants.HEADER_3 === this.variant) {
      const burgerMenu = document.querySelector('.burger-menu');

      if (burgerMenu) {
        burgerMenu.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleBurgerMenu();
        });
      }
    }

    if (this.menuVisible) {
      document.body.classList.add('no-scroll');
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove('no-scroll');
  },
});
</script>

<style>
.no-scroll {
  overflow: hidden;
}
</style>

<style scoped>
.nav-menu {
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease-in-out;
}

.navbar {
  transition: all 0.5s ease-in-out;
}
.nav-item {
  transform: translateY(-20px);
  opacity: 0;
  transition: all 0.4s ease-in-out;
}

.nav-item-visible {
  transform: translateY(0);
  opacity: 1;
}

.burger-menu-visible .nav-menu {
  opacity: 1;
  pointer-events: initial;
}

.burger-menu-visible .navbar {
  background-color: var(--c-primary) !important;
}

button.icon {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: transparent;
  cursor: pointer;
  align-items: center;
  width: 56px;
  height: 56px;
  justify-content: center;
}

button.icon > span {
  height: 3px;
  width: 22px;
  background: inherit;
  transition: all 0.3s linear;
}

button.icon > span:last-child {
  height: 3px;
}

/* Hover effects */
button.icon:hover > span:first-child {
  width: 11px;
  margin-left: 11px;
}

button.icon.active > span:last-child {
  opacity: 0;
}

button.icon.active:hover > span:first-child {
  width: 22px;
  margin-left: 0;
}

button.icon.active > span {
  transform: rotate(45deg);
  margin-bottom: -3px;
}

button.icon.active > span.active {
  background: #fff !important;
}

button.icon.active > span:nth-child(2) {
  width: 22px;
  margin-left: 0;
  margin-top: -5px;
  transform: rotate(-45deg);
  margin-bottom: 0;
}

button.icon span {
  transition: 0.3s ease-in-out;
}

.scrolled {
  animation: fadeIn 0.8s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    top: -50px;
  }
  to {
    opacity: 1;
    top: 0;
  }
}
</style>
